var _ellipse, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExamination(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 52,
    viewBox: "0 0 53 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.6172,
    cy: 26,
    rx: 26,
    ry: 26,
    fill: "#8954E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6185 29.2507C30.8066 29.2507 34.2018 25.8555 34.2018 21.6673C34.2018 17.4792 30.8066 14.084 26.6185 14.084C22.4303 14.084 19.0352 17.4792 19.0352 21.6673C19.0352 25.8555 22.4303 29.2507 26.6185 29.2507Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6178 9.75C24.1641 9.74906 21.7699 10.5059 19.7626 11.9171C17.7552 13.3282 16.2326 15.3249 15.4029 17.6341C14.5731 19.9433 14.4768 22.4524 15.1269 24.8184C15.7771 27.1845 17.1421 29.292 19.0353 30.853V41.1667C19.0353 41.3513 19.0825 41.533 19.1724 41.6943C19.2623 41.8556 19.392 41.9912 19.5491 42.0883C19.7062 42.1854 19.8855 42.2407 20.07 42.249C20.2545 42.2572 20.438 42.2182 20.6032 42.1356L26.6177 39.1279L32.6342 42.1357C32.7994 42.2182 32.9829 42.2572 33.1674 42.2489C33.3519 42.2406 33.5311 42.1853 33.6882 42.0882C33.8453 41.9911 33.9749 41.8555 34.0648 41.6942C34.1548 41.5329 34.202 41.3513 34.202 41.1667V30.8517C36.0948 29.2905 37.4593 27.1829 38.1091 24.8169C38.759 22.451 38.6623 19.9421 37.8325 17.6331C37.0026 15.3241 35.48 13.3277 33.4727 11.9168C31.4654 10.5058 29.0714 9.74906 26.6178 9.75ZM26.6178 31.4167C24.6895 31.4167 22.8044 30.8448 21.201 29.7735C19.5976 28.7022 18.348 27.1794 17.61 25.3978C16.8721 23.6163 16.679 21.6559 17.0552 19.7645C17.4314 17.8732 18.36 16.1359 19.7235 14.7724C21.0871 13.4088 22.8244 12.4802 24.7157 12.104C26.607 11.7278 28.5674 11.9209 30.349 12.6588C32.1306 13.3968 33.6533 14.6465 34.7247 16.2499C35.796 17.8532 36.3678 19.7383 36.3678 21.6667C36.3649 24.2516 35.3368 26.7299 33.5089 28.5577C31.6811 30.3856 29.2028 31.4138 26.6178 31.4167Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExamination);
export default __webpack_public_path__ + "static/media/examination.707e16e1129060bd42d292a96851c038.svg";
export { ForwardRef as ReactComponent };